import {useTestObservationQuery} from './useTestObservationsQuery';

// FNP-861: single-record read for the detail view. Read-only — no update/delete.
export const useTestObservation = (id: string) => {
    const query = useTestObservationQuery(id);

    return {
        record: query.data,
        loading: query.isLoading,
        // Surface error and fetched-but-empty separately so the detail page can show
        // an explicit "not found" instead of spinning forever on an id that does not
        // resolve.
        isError: query.isError,
        notFound: query.isFetched && !query.data,
    };
};
